import AbstractAuthenticatedService from '../../../model/service/abstract-authenticated-service';
import ActionService from './action-service';
import ConditionService from './condition-service';
import RuleService from './rule-service';
export default class MappingService extends AbstractAuthenticatedService {
    get ruleService() {
        if (!this._ruleService) {
            this._ruleService = new RuleService(this.store, this.authenticationService);
        }
        return this._ruleService;
    }
    get conditionService() {
        if (!this._conditionService) {
            this._conditionService = new ConditionService(this.store, this.authenticationService);
        }
        return this._conditionService;
    }
    get actionService() {
        if (!this._actionService) {
            this._actionService = new ActionService(this.store, this.authenticationService);
        }
        return this._actionService;
    }
}
//# sourceMappingURL=mapping-service.js.map